export class BaseGetModel<T> {
  items: T[]
  count: number
}
